import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import TrendingSection from './components/TrendingSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "糖心视频",
            "url": "https://tangxin.com",
            "description": "糖心视频官网提供免费在线影视观看，高清不缓冲，热门电影、电视剧、综艺免费追剧。",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://tangxin.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            },
            "publisher": {
              "@type": "Organization",
              "name": "糖心视频",
              "url": "https://tangxin.com",
              "logo": "https://tangxin.com/logo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "400-888-9999",
                "contactType": "customer service",
                "availableLanguage": "Chinese"
              }
            }
          })
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <StatsSection />
          <TrendingSection />
          <CategorySection />
          <ArticleSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}